export const LS_DASHBOARD_CONTAINER_INFORMATION_WIDGET_KEY =
  '__app_dashboard_containerInformationWidget'
